import { render, staticRenderFns } from "./VContractDetails.vue?vue&type=template&id=118e8a56&"
import script from "./VContractDetails.vue?vue&type=script&lang=js&"
export * from "./VContractDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports